import { http, httpNoTimeout, libHttp } from "./http"
import { DocType, Document } from "models/documents"

export const fetchCampaignDocuments = async (_key: string, id: string) => {
  const res = await http(
    `campaigns/${id}/documents?sort=DATE_CREATED,DESC`,
  ).json()
  return res as Array<Document>
}

export const fetchPlanCreatives = async (_key: string, id: string) => {
  const res = await http(
    `media-plans/${id}/documents?sort=DATE_CREATED,DESC`,
  ).json()
  return res as Array<Document>
}

type UploadCampaignDocPld = {
  file?: File
  mediaType?: string
  description?: string
  ownerEntityId: string
  documentType?: DocType
}

export const uploadCampaignDocument = async (pld: UploadCampaignDocPld) => {
  if (pld.file === undefined) return
  const { file, ownerEntityId, documentType, description } = pld
  const formData = new FormData()
  formData.append("file", file)
  formData.append("name", file.name)
  if (documentType !== undefined) {
    formData.append("documentType", documentType)
  }
  if (description !== undefined) {
    formData.append("description", description)
  }

  const res = await httpNoTimeout
    .post(`campaigns/${ownerEntityId}/documents`, { body: formData })
    .json()
  return res
}

type UploadPlanCrtvPld = {
  file?: File
  mediaType?: string
  description?: string
  ownerEntityId: string
  documentType?: DocType
}

export const uploadPlanCreative = async (pld: UploadPlanCrtvPld) => {
  if (pld.file === undefined) return
  const { file, ownerEntityId, description, mediaType } = pld
  const formData = new FormData()
  formData.append("file", file)
  formData.append("name", file.name)
  if (mediaType !== undefined) {
    formData.append("tags", mediaType)
  }
  if (description !== undefined) {
    formData.append("description", description)
  }

  const res = await httpNoTimeout
    .post(`media-plans/${ownerEntityId}/documents`, { body: formData })
    .json()
  return res
}

export const deleteCampaignDocument = async (id: string) => {
  await http.delete(`campaigns/documents/${id}`)
}

export const deletePlanCreative = async (id: string) => {
  await http.delete(`media-plans/documents/${id}`)
}

export const downloadDocument = async (id: string, filename: string) => {
  const blob = await libHttp(`documents/${id}/file`).blob()
  const objectUrl = URL.createObjectURL(blob)
  var fileLink = document.createElement("a")
  fileLink.href = objectUrl
  fileLink.download = filename
  fileLink.click()
}
